import { useParams } from "react-router";

import { Link } from "../../../types/api";
import { getJSON, post } from "../infrastructure/digipost-fetch";
import { findURIWithWindowHostname } from "../infrastructure/link";

interface OAuthToken {
  appName: string;
  description: string;
  givenAccess: Array<string>;
  link: Array<Link>;
  missingAccess: Array<string>;
  redirectUri: string;
  scope: string;
  state: string;
  tokenId: string;
  tokenType: string;
  vendor: string;
}

export const useTokenParam = (): string => {
  const { token } = useParams();

  if (token === undefined) {
    throw new Error("Token is missing from URL params");
  }

  return token;
};

export const useIdportenLevelParam = (): string => {
  const { idportenLevel } = useParams();

  if (idportenLevel === undefined) {
    throw new Error("idporten level is missing from URL params");
  }

  if (idportenLevel == "idporten3") {
    return "IDPORTEN_NIVAA_3";
  }

  if (idportenLevel == "idporten4") {
    return "IDPORTEN_NIVAA_4";
  }

  throw new Error(
    "idporten level is missing from URL params, invalid value found",
  );
};

export const getTokenObjectFromBackend = async (
  token: string,
  timeoutMs = 5000,
): Promise<OAuthToken> => {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    try {
      return getJSON<OAuthToken>(`/post/api/oauth/authorize/tokens/${token}`);
    } catch {
      await new Promise((res) => setTimeout(res, 500));
    }
  }
  throw new Error("getTokenObject Timeout");
};

export const getTokenApproveCode = async (
  tokenObject: OAuthToken,
  csrfToken: string,
  timeoutMs = 5000,
): Promise<string> => {
  const approveUrl = findURIWithWindowHostname(
    "token_approve",
    tokenObject.link,
  );
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    try {
      const tokenApproveResponse = await post(approveUrl, {}, csrfToken);
      const tokenApproveJSON = await tokenApproveResponse.json();
      return tokenApproveJSON.code;
    } catch {
      await new Promise((res) => setTimeout(res, 500));
    }
  }
  throw new Error("getTokenApproveCode Timeout");
};
